import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';

export const WishlistSkeleton = () => (
  <div data-testid="wishlist-skeleton">
    <Skeleton className="h-[400px]" />
  </div>
);
